import { EntityOperation, logEntityOperationFailure } from 'serviceWorker/helpers/entityFailureLog';
import type { AnyChannelContract } from 'shared/channels/contract';
import { noop } from 'shared/utils/function';
import { markPullStep, PullStep, readPullStep } from './pullProgress';

interface BackgroundPull {
  entityName: string;
  contract: Pick<AnyChannelContract, 'key'>;
}

/**
 * Runs a pull or sync nobody needs the result of (a debounced sync, a retry,
 * the first download of a read). Its failure is logged with the step the pull
 * got to, instead of being lost as an unhandled rejection that leaves readers
 * waiting without a trace. Never rejects: it resolves once the run ended.
 */
export function runPullInBackground({ entityName, contract }: BackgroundPull, run: () => Promise<unknown>): Promise<void> {
  return run().then(noop, (error: unknown) => {
    const lastPullStep = readPullStep(contract);
    markPullStep(contract, PullStep.failed);
    logEntityOperationFailure(EntityOperation.SYNCING, { entityName, error, setup: { lastPullStep } });
  });
}
